import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Principal.css';
import CONFIG from '../../config.js';
import PrincipalEstudiante from './PrincipalEstudiante.js';


const URL_INFO = `${CONFIG.API_URL}/info_principal_tutor.php`;
const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalTutor({rol, configuracion, mensajesSinLeer}) {
    const userId =localStorage.getItem('loggeduserId');
    const [eventos, setEventos] = useState([]);
    const loggeduserId =localStorage.getItem('loggeduserId');
    const [estudiantesACargo, setEstudiantesACargo] = useState([]);
		const [verEstudiante, setVerEstudiante] = useState(0);

     useEffect(() => {
            obtenerEventos();
    }, []);

		useEffect(() => {
			buscaInfoVinculacion();
		}, []);
    
		const buscaInfoVinculacion = () => {
        axios.get(`${URL_INFO}?id_tutor=${loggeduserId}`)
            .then(res => {
                if (!res.data.error) { 
                    console.log(res.data.datos);
                    setEstudiantesACargo(res.data.datos);
                } else {
                    setEstudiantesACargo([]);
										console.log(res.data.mensaje);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const obtenerEventos = async () => {
        try {
            const res = await axios.get(URL_CALENDARIO);
            if (Array.isArray(res.data)) {
                // Aplicar filtros según el rol
                const eventosFiltrados = res.data.filter(evento => {
                    const esPropio = evento.creada_por == userId;
    
                    let filtroPorRol = false;
                    switch (rol) {
                        case 1:
                        case 2:
                            filtroPorRol = ['todos', 'todosA', 'todosD', 'todosE','todosT','todosM'].includes(evento.tipo_recordatorio);
                            break;
                        case 3:
                        case 4:
                            filtroPorRol = ['todos', 'todosA'].includes(evento.tipo_recordatorio);
                            break;
                        case 5:
                            filtroPorRol = ['todos', 'todosA', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 6:
                            filtroPorRol = ['todos', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 9:
                            filtroPorRol = ['todos', 'todosD'].includes(evento.tipo_recordatorio);
                            break;
                        case 7:
                            filtroPorRol = ['todos', 'todosE'].includes(evento.tipo_recordatorio);
                            break;
                        case 8:
                            filtroPorRol = ['todos', 'todosT'].includes(evento.tipo_recordatorio);
                            break;
                        case 12:
                            filtroPorRol = ['todos', 'todosM'].includes(evento.tipo_recordatorio);
                            break;
                        default:
                            filtroPorRol = false;
                            break;
                    }
    
                    return esPropio || filtroPorRol;
                });
    
                setEventos(eventosFiltrados);
            } else {
                setEventos([]);
                console.error('La respuesta de la API no es un array:', res.data);
            }
        } catch (err) {
            console.error('Error al obtener eventos:', err);
        }
    };

    const eventosHoy = () => {
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0); // Asegúrate de comparar solo las fechas

        return eventos.filter((evento) => {
            const fechaEvento = new Date(evento.fecha);
            fechaEvento.setHours(0, 0, 0, 0);
            return fechaEvento.getTime() === fechaActual.getTime();
        });
    };

    const proximosEventos = (dias_proximos) => {
        const fechaActual = new Date();
        const fechaLimite = new Date();
        fechaLimite.setDate(fechaActual.getDate() + dias_proximos);

        return eventos.filter((evento) => {
            const fechaEvento = new Date(evento.fecha);
            return fechaEvento >= fechaActual && fechaEvento <= fechaLimite;
        });
    };
    
    const mostrarNombre = (orden)=>{
			let nombre="";
			switch(orden){  
				case "S2":
					nombre='Sala de 2';
					break        
				case "S3":
					nombre='Sala de 3';
				break
				case "S4":
					nombre='Sala de 4';
				break
				case "S5":
					nombre='Sala de 5';
				break
				case "In":
					nombre='Espacio Institucional';
				break
				default:
					nombre=orden+'°';
			}
			return nombre
		};

    return (   
        <>
				{verEstudiante == 0 ?
				<>
          <h5>Área para tutores</h5>
          <div className='text-center'>
						<button type="button" className="btn btn-primary">Inscribir un estudiante a mi cargo a un curso</button>
					</div>
					<hr/>
          <div className='row'>
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='card px-2'>
                <div className="principal-card">
                  <div className='principal-caja-circulo-logo'><i className='fa-solid fa-envelope'></i></div>
                  <div className='principal-caja-borde-logo'></div>
                  <div className='principal-card-titulo '>Mensajes sin leer</div>
                  <div className='d-flex justify-content-center principal-texto-info-rojo'>{mensajesSinLeer}</div>                                    
                </div>
                <div className=''>
                  <div className='card mb-3'>
                    <div className='card-body'>
                      <div className='card-title'>
                        <h5>Eventos de Hoy:</h5>
                      </div>
                      {eventosHoy().map((evento) => (
                        <div key={evento.id_evento}>
                          <strong>{evento.evento}</strong> - {evento.hora_desde} a {evento.hora_hasta}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='card mb-3'>
                    <div className='card-body'>
                      <div className='card-title'>
                        <h5>Próximos eventos <small>(15 días)</small>:</h5 >
                      </div>
                      {proximosEventos(15).map((evento) => (
                        <div key={evento.id_evento}>
                          <strong>{evento.evento}</strong> - {new Date(evento.fecha).toLocaleDateString()} ({evento.hora_desde} - {evento.hora_hasta})
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                                    
              </div>
            </div>
            <div className='col-12 col-md-6 col-lg-8'>
              <div className='card px-4 pb-4'>
                <h5 className='mt-2'>Estudiantes vinculados</h5>                        
                <div className=''>
											{estudiantesACargo.map((e)=>(
												<div key={e.estudiante_id}>
													<strong>{e.nombre}, {e.apellido}</strong> (<strong>{mostrarNombre(e.orden)}</strong>)
													<button className='btn btn-sm btn-outline-primary mx-1' on onClick={()=>setVerEstudiante(e.estudiante_id)}>Ver como {e.nombre}</button>
												</div>
											))}
                </div>
              </div>                   
            </div>
          </div>
					</>
					:
					<PrincipalEstudiante rol={rol} configuracion={configuracion} verTutor={verEstudiante} />
					}
        </>                
     );
}

export default PrincipalTutor;